import CartShort from "../../utils/cart-short";
import Popup from "../../utils/popup";

class Bilety {
  constructor() {
    //this.form = $("#rezerwacja");
    this.form = $("#nienumerowane");
    this.changeButton = this.form.find(".change-button");
    this.input = this.form.find("input");
    this._params = null;
    this._tours = null;
    this.cartShort = new CartShort();
    this._changedInput = {
      selector: null,
      oldValue: null,
      newValue: null
    };
    this._currency = "";
  }

  get params() {
    return this._params;
  }

  set params(value) {
    this._params = value;
    // Dynamiczne dodawanie do koszyka wyłączone
    //this.sendAjaxRequest();
    //
    this.getTransactionsValue();
  }

  get tours() {
    return this._tours;
  }

  set tours(value) {
    this._tours = value;
  }

  get changedInput() {
    return this._changedInput;
  }

  set changedInput(obj) {
    Object.assign(this._changedInput, obj);
  }

  get currency() {
    return this._currency;
  }

  set currency(value) {
    this._currency = value;
  }

  events() {
    const _this = this;

    this.changeButton.on("click", function() {
      let minusButton = $(this).hasClass("minus");
      let plusButton = $(this).hasClass("plus");
      let input = $(this)
        .parent()
        .find("input.count");

      if (minusButton) {
        if (!input.hasClass("is-invalid")) {
          _this.decreaseInputValue(input);
        }
      } else if (plusButton) {
        if (!input.hasClass("is-invalid")) {
          _this.increaseInputValue(input);
        }
      }
    });

    this.input.on("blur", function() {
      if (!$(this).hasClass("is-invalid")) {
        let inputValue = $(this).val();

        _this.changedInput = {
          selector: $(this),
          newValue: inputValue
        };

        _this.getTransactionsValue();
      }
    });
  }

  increaseInputValue(input) {
    let inputValue = input.val();

    this.changedInput = {
      selector: input,
      oldValue: inputValue
    };

    inputValue++;
    if (inputValue <= 999) {
      this.changedInput = {
        newValue: inputValue
      };
      input.val(inputValue);
      this.params = this.form.serializeArray();
    }
  }

  decreaseInputValue(input) {
    let inputValue = input.val();

    this.changedInput = {
      selector: input,
      oldValue: inputValue
    };

    inputValue--;
    if (inputValue >= 0) {
      this.changedInput = {
        newValue: inputValue
      };
      input.val(inputValue);
      this.params = this.form.serializeArray();
    }
  }

  sendAjaxRequest() {
    const _this = this;
    const url =
      this.form.attr("action") + "&json=true&ajax_action=zablokuj_miejsca";
    const params = _this.params;

    params.push({
      //name: "rezerwacja-submit",
      name: "nienumerowane-submit",
      value: "Kontynuuj"
    });

    this.changedInput.selector.parent().addClass("preloader");

    $.ajax({
      method: "POST",
      url: url,
      data: params
    })
      .done(function(response) {
        _this.changedInput.selector.parent().removeClass("preloader");

        // Błąd
        if (response.status === "error") {
          _this.changedInput.selector.val(_this.changedInput.oldValue);

          // Popup z komunikatem błędu
          let popup = new Popup(response.message);
          popup.showPopup();

          return false;
        }
        // Ustawinie waluty
        _this.currency = response.data.waluta;
        //
        _this.cartShort.data = response.data;
      })
      .fail(function() {
        console.error("error");
      });
  }

  getTransactionsValue() {
    let priceUnit = this.changedInput.selector
      .parents(".fr-transactions__item")
      .find(".fr-transactions__price-unit")
      .attr("data-price-unit");

    let quantity = this.changedInput.newValue;
    let oldPrice = this.changedInput.selector
      .parents(".fr-transactions__item")
      .find(".fr-transactions__price")
      .text();

    this.changedInput.selector
      .parents(".fr-transactions__item")
      .find(".fr-transactions__price")
      .text(oldPrice.replace(/[0-9.]+/, (priceUnit * quantity).toFixed(2)));
  }

  init() {
    this.events();
  }
}

export default Bilety;
